export default __webpack_public_path__ + "static/media/radio_button_unchecked-teal.1c5e179b.svg";